import { GMTInfo } from './common';
import { useRequestImmer } from '../api/hooks';

export const CategoryEndpoint = `/category`;

export interface Category extends GMTInfo {
  id: number;

  /**类目名 */
  name: string;

  /**类目描述 */
  desc: string;

  /**类目关键字 */
  keywords?: string[];

  /**父类目 id */
  pid?: number;

  /**图标 */
  iconUrl: string;

  /**图片 */
  picUrl: string;

  /**排序 */
  sortOrder: number;

  /**小程序上架 */
  isOnSale: boolean;
}

export const requestCategoryList = () =>
  useRequestImmer<{
    list: Category[];
  }>(
    {
      method: 'get',
      url: `${CategoryEndpoint}`,
    },
    {
      manual: true,
    }
  );

// export const useRequestCategoryListWithDefault = () => {
//   const { payload, setPayload, ...rest } = useRequestImmer<{
//     list: Category[];
//   }>(
//     {
//       method: 'get',
//       url: `${CategoryEndpoint}`,
//     },
//     {
//       manual: true,
//     }
//   );
//
//   useEffect(() => {
//     if (payload) {
//       setPayload(draft => {
//         draft.list.splice(0, 0, {
//           id: 0,
//           name: '默认品类',
//         } as Category);
//       });
//     }
//   }, [payload]);
//
//   return {
//     payload,
//     setPayload,
//     ...rest,
//   };
// };
